module.exports = __webpack_public_path__ + "img/17.1d5f48c1.webp";